<template>
  <v-row justify="center">
    <v-dialog v-model="show" persistent max-width="1000">
      <custom-modal
        title="Cheque Details"
        @onClose="
          onClose();
          show = false;
        "
        :isLoading="isLoading"
        :showSave="false"
      >
        <v-container fluid class="lighten-12 container">
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-row>
                <v-col cols="12" sm="12" md="12" lg="12">
                  <v-card class="lighten-12">
                    <v-card-title class="v-card__title saletiltle"
                      ><v-icon color="blue" small>mdi-sale</v-icon
                      ><span class="ml-3"> Cheque Details </span></v-card-title
                    >
                    <v-container fluid class="container saledetailscard">
                      <v-row>
                        <v-col cols="12" sm="12" md="12" lg="12" class="pt-0">
                          <v-row class="pt-0">
                            <v-col
                              cols="12"
                              sm="12"
                              md="2"
                              lg="2"
                              class="pr-5pt-1.5 pb-1 reference_number"
                              @click="onChequeClick(cheque)"
                            >
                              <!-- <v-icon small color="primary"
                                >mdi-checkbook</v-icon
                              > -->
                              <v-chip
                                color="green"
                                class="pa-0 pulse pointer"
                                outlined
                              >
                                {{ cheque.number }}
                              </v-chip>
                            </v-col>

                            <v-col cols="12" sm="12" md="5" lg="5"
                              ><span class="statustext pr-5">Cheque for</span
                              ><v-chip
                                label
                                text-color="white"
                                style="
                                  font-variant-caps: all-small-caps;
                                  font-weight: bold;
                                  background-color: #c11e65;
                                "
                                dark
                                v-if="this.isSale"
                              >
                                Sale
                              </v-chip>
                              <v-chip
                                label
                                text-color="white"
                                style="
                                  font-variant-caps: all-small-caps;
                                  font-weight: bold;
                                  background-color: #c11e65;
                                "
                                dark
                                v-else-if="this.isPurchase"
                              >
                                Purchase
                              </v-chip>
                              <v-chip
                                label
                                text-color="white"
                                style="
                                  font-variant-caps: all-small-caps;
                                  font-weight: bold;
                                  background-color: #c11e65;
                                "
                                dark
                                v-else
                              >
                                {{ cheque.chequeFor }}
                              </v-chip>
                              <v-menu
                                offset-y
                                v-if="
                                  cheque.chequeFor != 'sale' &&
                                  cheque.chequeFor != 'purchase'
                                "
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                    large
                                    color="primary darken-2"
                                    v-bind="attrs"
                                    v-on="on"
                                    class="ma-1 white ml-2"
                                  >
                                    mdi-checkbox-multiple-marked-circle-outline
                                  </v-icon>
                                </template>
                                <v-list>
                                  <v-list-item
                                    v-for="(item, index) in items"
                                    :key="index"
                                    link
                                    @click="changePaymentType(item)"
                                  >
                                    <v-list-item-title>{{
                                      item.title
                                    }}</v-list-item-title>
                                  </v-list-item>
                                </v-list>
                              </v-menu>
                              <v-row v-if="showChequefor">
                                <v-col
                                  cols="6"
                                  sm="6"
                                  md="6"
                                  lg="6"
                                  class="text-right"
                                  v-if="isSale"
                                >
                                  <SaleAutoComplete v-model="paymentableId">
                                  </SaleAutoComplete>
                                </v-col>
                                <v-col
                                  cols="6"
                                  sm="6"
                                  md="6"
                                  lg="6"
                                  class="text-right"
                                  v-if="isPurchase"
                                >
                                  <PurchaseAutoComplete
                                    v-model="paymentableId"
                                  ></PurchaseAutoComplete>
                                </v-col>
                                <v-col
                                  cols="6"
                                  sm="6"
                                  md="6"
                                  lg="6"
                                  class="text-left"
                                  v-if="isPurchase || isSale"
                                >
                                  <v-btn
                                    color="green"
                                    x-small
                                    dark
                                    :disabled="isDisabledChequefor"
                                    @click="updateChequeFor()"
                                  >
                                    <v-icon link @click="updateChequeFor()"
                                      >done</v-icon
                                    >
                                  </v-btn>
                                  <v-btn
                                    color="secondary"
                                    x-small
                                    dark
                                    class="ma-1"
                                    @click="cancelChequeFor()"
                                  >
                                    <v-icon
                                      depressed
                                      small
                                      link
                                      @click="cancelChequeFor()"
                                      >clear</v-icon
                                    >
                                  </v-btn>
                                </v-col>
                              </v-row>
                            </v-col>

                            <v-col cols="12" sm="12" md="4" lg="4">
                              <span class="statustext pr-5">Status</span>

                              <v-chip
                                label
                                :color="getStatusColor(cheque.status)"
                                text-color="white"
                              >
                                <strong>{{ cheque.status }}</strong>
                              </v-chip>

                              <v-tooltip
                                bottom
                                v-if="
                                  showEditCheque && cheque.status == 'Pending'
                                "
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    class="ma-1 white ml-5"
                                    x-small
                                    color="black"
                                    v-bind="attrs"
                                    v-on="on"
                                    icon
                                    @click="editChequeStatus"
                                  >
                                    <v-icon color="primary" small>edit</v-icon>
                                  </v-btn>
                                </template>
                                <span>Change Status</span>
                              </v-tooltip>

                              <v-tooltip
                                bottom
                                v-if="
                                  showEditCheque && cheque.status == 'Completed'
                                "
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    class="ma-1 white ml-2"
                                    x-small
                                    color="black"
                                    v-bind="attrs"
                                    v-on="on"
                                    icon
                                    @click="editChequeCompleteStatus"
                                  >
                                    <v-icon>edit</v-icon>
                                  </v-btn>
                                </template>
                                <span>Change Status</span>
                              </v-tooltip>
                            </v-col>
                            <v-row>
                              <v-col cols="6" sm="6" md="6" lg="6"> </v-col>
                              <v-col
                                v-if="!showEditCheque"
                                cols="12"
                                sm="12"
                                md="12"
                                lg="6"
                                class="sub-section"
                              >
                                <v-row>
                                  <v-col cols="12" sm="12" md="12" lg="12">
                                    <v-select
                                      v-if="!showEditCheque"
                                      hide-details="auto"
                                      :items="status"
                                      v-model="selectedStatus"
                                      item-text="text"
                                      item-value="value"
                                      outlined
                                      dense
                                      label="Status"
                                      @change="setShowReason"
                                    ></v-select>
                                  </v-col>
                                </v-row>

                                <ValidationObserver ref="observer">
                                  <v-row v-if="showReason">
                                    <v-col
                                      cols="12"
                                      sm="12"
                                      md="12"
                                      lg="12"
                                      class="pb-0"
                                    >
                                      <ValidationProvider
                                        name="Reason"
                                        rules="required"
                                        v-slot="{ errors }"
                                      >
                                        <v-textarea
                                          :error-messages="errors"
                                          required
                                          v-model="reason"
                                          label="Reason"
                                          auto-grow
                                          rows="3"
                                          row-height="20"
                                          outlined
                                        ></v-textarea>
                                      </ValidationProvider>
                                    </v-col>
                                  </v-row>
                                </ValidationObserver>
                                <v-row>
                                  <v-col
                                    cols="12"
                                    sm="12"
                                    md="12"
                                    lg="12"
                                    v-if="!showEditCheque"
                                    class="d-flex justify-content-end py-0 align-center"
                                  >
                                    <v-btn
                                      color="green"
                                      x-small
                                      dark
                                      :disabled="isDisabled"
                                      @click="updateChequeStatus()"
                                    >
                                      <v-icon
                                        link
                                        :disabled="isDisabled"
                                        @click="updateChequeStatus()"
                                        >done</v-icon
                                      >
                                    </v-btn>
                                    <v-btn
                                      color="secondary"
                                      x-small
                                      dark
                                      class="ma-1"
                                      @click="cancelEditChequeStatus(item)"
                                    >
                                      <v-icon
                                        depressed
                                        small
                                        link
                                        @click="cancelEditChequeStatus(item)"
                                        >clear</v-icon
                                      >
                                    </v-btn>
                                  </v-col>
                                </v-row>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" sm="12" md="12" lg="6"> </v-col>
                              <v-col
                                v-if="!showCompleteCheque"
                                cols="12"
                                sm="12"
                                md="12"
                                lg="6"
                                class="sub-section"
                              >
                                <v-row>
                                  <v-col cols="12">
                                    <v-select
                                      v-if="!showCompleteCheque"
                                      hide-details="auto"
                                      :items="statusComplete"
                                      v-model="selectedStatus"
                                      item-text="text"
                                      item-value="value"
                                      outlined
                                      dense
                                      label="Status"
                                      @change="setShowReason"
                                    ></v-select>
                                  </v-col>
                                </v-row>

                                <ValidationObserver ref="observer">
                                  <v-row>
                                    <v-col
                                      cols="12"
                                      sm="12"
                                      md="12"
                                      lg="12"
                                      class="pb-0"
                                    >
                                      <ValidationProvider
                                        name="Reason"
                                        rules="required"
                                        v-slot="{ errors }"
                                      >
                                        <v-textarea
                                          :error-messages="errors"
                                          required
                                          v-model="reason"
                                          label="Reason"
                                          auto-grow
                                          rows="3"
                                          row-height="20"
                                          outlined
                                        ></v-textarea>
                                      </ValidationProvider>
                                    </v-col>
                                  </v-row>
                                </ValidationObserver>
                                <v-row>
                                  <v-col
                                    cols="12"
                                    sm="12"
                                    md="12"
                                    lg="6"
                                    v-if="!showCompleteCheque"
                                    class="d-flex justify-content-end py-0 align-center"
                                  >
                                    <v-btn
                                      color="green"
                                      x-small
                                      dark
                                      :disabled="isDisabled"
                                      @click="updateChequeStatus()"
                                    >
                                      <v-icon
                                        link
                                        :disabled="isDisabled"
                                        @click="updateChequeStatus()"
                                        >done</v-icon
                                      >
                                    </v-btn>
                                    <v-btn
                                      color="secondary"
                                      x-small
                                      dark
                                      class="ma-1"
                                      @click="cancelEditChequeStatus(item)"
                                    >
                                      <v-icon
                                        depressed
                                        small
                                        link
                                        @click="cancelEditChequeStatus(item)"
                                        >clear</v-icon
                                      >
                                    </v-btn>
                                  </v-col>
                                </v-row>
                              </v-col>
                            </v-row>
                          </v-row>
                          <v-row>
                            <v-col
                              cols="12"
                              sm="12"
                              md="2"
                              lg="2"
                              class="shoptext pr-5 pt-0"
                            >
                              <v-row class="subtextlable"> Bank </v-row>
                              <v-row>
                                <v-icon x-small>mdi-bank</v-icon>
                                {{ cheque.bank }}
                              </v-row>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="12"
                              md="2"
                              lg="2"
                              class="shoptext pr-5 pt-0"
                            >
                              <v-row class="subtextlable"> Create Date </v-row>
                              <v-row>
                                <v-icon small>mdi-calendar</v-icon>
                                {{ cheque.date_time | formatDate }}
                              </v-row>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="12"
                              md="2"
                              lg="2"
                              class="shoptext pr-5 pt-0"
                            >
                              <v-row class="subtextlable"> Cheque Date </v-row>
                              <v-row>
                                <v-icon small>mdi-calendar</v-icon>
                                {{ cheque.date | formatDate }}
                              </v-row>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="12"
                              md="2"
                              lg="2"
                              class="shoptext pr-5 pt-0"
                            >
                              <v-row
                                class="subtextlable"
                                v-if="cheque.chequeFor == 'purchase'"
                              >
                                Supplier
                              </v-row>
                              <v-row class="subtextlable" v-else>
                                Customer
                              </v-row>
                              <v-row v-if="cheque.chequeFor == 'purchase'">
                                {{ cheque.supplier }}
                              </v-row>
                              <v-row v-else>
                                {{
                                  cheque.customer ? cheque.customer.name : '--'
                                }}
                              </v-row>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="12"
                              md="1"
                              lg="1"
                              class="shoptext pr-5 pt-0"
                            >
                              <v-row class="subtextlable"> Type </v-row>
                              <v-row>
                                {{ cheque.type }}
                              </v-row>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="12"
                              md="2"
                              lg="2"
                              class="shoptext pr-5 pt-0"
                            >
                              <v-row class="subtextlable"> Amount </v-row>
                              <v-row>
                                <v-chip
                                  color="green"
                                  class="pa-0 pulse"
                                  outlined
                                >
                                  Rs. {{ cheque.amount | formatCurrency }}
                                </v-chip>
                              </v-row>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="12"
                              md="1"
                              lg="1"
                              class="shoptext pr-5 pt-0"
                            >
                              <v-row class="subtextlable"> Note </v-row>
                              <v-row>
                                {{ cheque.remarks ? cheque.remarks : '---' }}
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>

            <!-- <v-col>
              <v-row v-if="cheque.chequeFor == 'other'">
                <v-col cols="6" sm="6" md="6" lg="3">
                  <h4>Create Date</h4>
                </v-col>
                <v-col cols="6" sm="6" md="6" lg="3" class="text-right">
                  <v-chip label
                    ><strong>
                      {{ cheque.date_time | formatDate }}
                    </strong></v-chip
                  >
                </v-col>
                <v-col cols="6" sm="6" md="6" lg="3">
                  <h4>Cheque Date</h4>
                </v-col>
                <v-col cols="6" sm="6" md="6" lg="3" class="text-right">
                  <v-chip label
                    ><strong> {{ cheque.date | formatDate }}</strong>
                  </v-chip>
                </v-col>
              </v-row>

              <v-row v-else>
                <v-col cols="6" sm="6" md="6" lg="2">
                  <h4>Number</h4>
                </v-col>
                <v-col cols="6" sm="6" md="6" lg="4" class="text-right">
                  <v-chip
                    label
                    class="text-decoration-underline"
                    te
                    color="#e91e63"
                    @click="onChequeClick(cheque)"
                  >
                    <strong>{{ cheque.number }}</strong></v-chip
                  >
                </v-col>
                <v-col cols="6" sm="6" md="6" lg="2">
                  <h4>Create Date</h4>
                </v-col>
                <v-col cols="6" sm="6" md="6" lg="4" class="text-right">
                  <v-chip label
                    ><strong> {{ cheque.date_time | formatDate }}</strong>
                  </v-chip>
                </v-col>
                <v-col cols="6" sm="6" md="6" lg="2">
                  <h4>Cheque for</h4>
                </v-col>
                <v-col cols="6" sm="6" md="6" lg="4" class="text-right">
                  <v-chip label
                    ><strong>{{ cheque.chequeFor }}</strong></v-chip
                  >
                </v-col>

                <v-col cols="6" sm="6" md="6" lg="2">
                  <h4>Cheque Date</h4>
                </v-col>
                <v-col cols="6" sm="6" md="6" lg="4" class="text-right">
                  <v-chip label
                    ><strong>{{ cheque.date | formatDate }}</strong></v-chip
                  >
                </v-col>
              </v-row>

              <v-row v-if="cheque.chequeFor != 'other'">
                <v-col
                  cols="6"
                  sm="6"
                  md="6"
                  lg="2"
                  v-if="cheque.chequeFor == 'purchase'"
                >
                  <h4>Supplier</h4>
                </v-col>
                <v-col v-else cols="6" sm="6" md="6" lg="2">
                  <h4>Customer</h4>
                </v-col>

                <v-col
                  cols="6"
                  sm="6"
                  md="6"
                  lg="4"
                  v-if="cheque.chequeFor == 'purchase'"
                  class="text-right"
                >
                  <v-chip label
                    ><strong>{{ cheque.supplier }}</strong></v-chip
                  >
                </v-col>

                <v-col v-else cols="6" sm="6" md="6" lg="4" class="text-right">
                  <v-chip label>
                    <strong>{{
                      cheque.customer ? cheque.customer.name : "--"
                    }}</strong></v-chip
                  >
                </v-col>

                <v-col cols="6" sm="6" md="6" lg="2" v-if="cheque.bank">
                  <h4>Bank</h4>
                </v-col>
                <v-col
                  cols="6"
                  sm="6"
                  md="6"
                  lg="4"
                  class="text-right"
                  v-if="cheque.bank"
                >
                  <v-chip label
                    ><strong>{{ cheque.bank }}</strong></v-chip
                  >
                </v-col>
              </v-row>

              <v-row v-else>
                <v-col cols="6" sm="6" md="6" lg="2">
                  <h4>Cheque for</h4>
                </v-col>
                <v-col cols="6" sm="6" md="6" lg="4" class="text-right">
                  <v-chip label
                    ><strong v-if="this.isSale">Sale</strong
                    ><strong v-else-if="this.isPurchase">Purchase</strong
                    ><strong v-else>{{ cheque.chequeFor }}</strong></v-chip
                  >
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        small
                        color="primary darken-2"
                        v-bind="attrs"
                        v-on="on"
                      >
                        mdi-checkbox-multiple-marked-circle-outline
                      </v-icon>
                    </template>
                    <v-list>
                      <v-list-item
                        v-for="(item, index) in items"
                        :key="index"
                        link
                        @click="changePaymentType(item)"
                      >
                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-col>
                <v-col cols="6" sm="6" md="6" lg="2">
                  <h4>Bank</h4>
                </v-col>
                <v-col cols="6" sm="6" md="6" lg="4" class="text-right">
                  <v-chip label
                    ><strong>{{ cheque.bank }}</strong></v-chip
                  >
                </v-col>
              </v-row>
              <v-row> </v-row>

              <v-row v-if="showChequefor">
                <v-col
                  cols="6"
                  sm="6"
                  md="6"
                  lg="4"
                  class="text-right"
                  v-if="isSale"
                >
                  <SaleAutoComplete v-model="paymentableId"> </SaleAutoComplete>
                </v-col>
                <v-col
                  cols="6"
                  sm="6"
                  md="6"
                  lg="4"
                  class="text-right"
                  v-if="isPurchase"
                >
                  <PurchaseAutoComplete
                    v-model="paymentableId"
                  ></PurchaseAutoComplete>
                </v-col>
                <v-col
                  cols="6"
                  sm="6"
                  md="6"
                  lg="2"
                  class="text-left"
                  v-if="isPurchase || isSale"
                >
                  <v-btn
                    color="green"
                    x-small
                    dark
                    :disabled="isDisabled"
                    @click="updateChequeFor()"
                  >
                    <v-icon link @click="updateChequeFor()">done</v-icon>
                  </v-btn>
                  <v-btn
                    color="secondary"
                    x-small
                    dark
                    class="ma-1"
                    @click="cancelChequeFor()"
                  >
                    <v-icon depressed small link @click="cancelChequeFor()"
                      >clear</v-icon
                    >
                  </v-btn>
                </v-col>

                <v-col cols="6" sm="6" md="6" lg="2">
                  <h4>Type</h4>
                </v-col>
                <v-col cols="6" sm="6" md="6" lg="4" class="text-right">
                  <v-chip label
                    ><strong>{{ cheque.type }}</strong></v-chip
                  >
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="6" sm="6" md="6" lg="2">
                  <h4>Amount</h4>
                </v-col>
                <v-col cols="6" sm="6" md="6" lg="4" class="text-right">
                  <v-chip label
                    ><strong>{{ cheque.amount }}</strong></v-chip
                  >
                </v-col>
                <v-col cols="6" sm="6" md="6" lg="2" v-if="showEditCheque">
                  <h4>Status</h4>
                </v-col>
                <v-col
                  cols="6"
                  sm="6"
                  md="6"
                  lg="4"
                  v-if="showEditCheque"
                  class="text-right"
                >
                  <v-chip
                    label
                    :color="getStatusColor(cheque.status)"
                    text-color="white"
                  >
                    <strong>{{ cheque.status }}</strong>
                  </v-chip>

                  <v-tooltip
                    bottom
                    v-if="showEditCheque && cheque.status == 'Pending'"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="ma-1 white ml-5"
                        x-small
                        color="black"
                        v-bind="attrs"
                        v-on="on"
                        icon
                        @click="editChequeStatus"
                      >
                        <v-icon>edit</v-icon>
                      </v-btn>
                    </template>
                    <span>Change Status</span>
                  </v-tooltip>

                  <v-tooltip
                    bottom
                    v-if="showEditCheque && cheque.status == 'Completed'"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="ma-1 white ml-5"
                        x-small
                        color="black"
                        v-bind="attrs"
                        v-on="on"
                        icon
                        @click="editChequeCompleteStatus"
                      >
                        <v-icon>edit</v-icon>
                      </v-btn>
                    </template>
                    <span>Change Status</span>
                  </v-tooltip>
                </v-col>
                <v-col cols="6" sm="6" md="6" lg="2" v-if="cheque.remarks">
                  <h4>Note</h4>
                </v-col>
                <v-col cols="6" sm="6" md="6" lg="4" v-if="cheque.remarks">
                  <v-chip label>{{ cheque.remarks }}</v-chip>
                </v-col>
                <v-col v-if="!showEditCheque" lg="6" class="sub-section">
                  <v-row>
                    <v-col cols="12">
                      <v-select
                        v-if="!showEditCheque"
                        hide-details="auto"
                        :items="status"
                        v-model="selectedStatus"
                        item-text="text"
                        item-value="value"
                        outlined
                        dense
                        label="Status"
                        @change="setShowReason"
                      ></v-select>
                    </v-col>
                  </v-row>

                  <ValidationObserver ref="observer">
                    <v-row v-if="showReason">
                      <v-col cols="12" class="pb-0">
                        <ValidationProvider
                          name="Reason"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <v-textarea
                            :error-messages="errors"
                            required
                            v-model="reason"
                            label="Reason"
                            auto-grow
                            rows="3"
                            row-height="20"
                            outlined
                          ></v-textarea>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                  </ValidationObserver>
                  <v-row>
                    <v-col
                      cols="12"
                      v-if="!showEditCheque"
                      class="d-flex justify-content-end py-0 align-center"
                    >
                      <v-btn
                        color="green"
                        x-small
                        dark
                        :disabled="isDisabled"
                        @click="updateChequeStatus()"
                      >
                        <v-icon link @click="updateChequeStatus()">done</v-icon>
                      </v-btn>
                      <v-btn
                        color="secondary"
                        x-small
                        dark
                        class="ma-1"
                        @click="cancelEditChequeStatus(item)"
                      >
                        <v-icon
                          depressed
                          small
                          link
                          @click="cancelEditChequeStatus(item)"
                          >clear</v-icon
                        >
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>

                <v-col v-if="!showCompleteCheque" lg="6" class="sub-section">
                  <v-row>
                    <v-col cols="12">
                      <v-select
                        v-if="!showCompleteCheque"
                        hide-details="auto"
                        :items="statusComplete"
                        v-model="selectedStatus"
                        item-text="text"
                        item-value="value"
                        outlined
                        dense
                        label="Status"
                        @change="setShowReason"
                      ></v-select>
                    </v-col>
                  </v-row>

                  <ValidationObserver ref="observer">
                    <v-row>
                      <v-col cols="12" class="pb-0">
                        <ValidationProvider
                          name="Reason"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <v-textarea
                            :error-messages="errors"
                            required
                            v-model="reason"
                            label="Reason"
                            auto-grow
                            rows="3"
                            row-height="20"
                            outlined
                          ></v-textarea>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                  </ValidationObserver>
                  <v-row>
                    <v-col
                      cols="12"
                      v-if="!showCompleteCheque"
                      class="d-flex justify-content-end py-0 align-center"
                    >
                      <v-btn
                        color="green"
                        x-small
                        dark
                        :disabled="isDisabled"
                        @click="updateChequeStatus()"
                      >
                        <v-icon link @click="uxpdateChequeStatus()">done</v-icon>
                      </v-btn>
                      <v-btn
                        color="secondary"
                        x-small
                        dark
                        class="ma-1"
                        @click="cancelEditChequeStatus(item)"
                      >
                        <v-icon
                          depressed
                          small
                          link
                          @click="cancelEditChequeStatus(item)"
                          >clear</v-icon
                        >
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <v-btn @click="PrintPdfConfirmation">Print</v-btn>
                </v-col>
              </v-row>

              <v-row>
                <v-col class="mt-5" cols="12 sub-section">
                  <FileUpload
                    v-if="show"
                    :multiple="true"
                    size="2048"
                    icon="mdi-upload"
                    autoupload="true"
                    :url="`document/upload/payment/${cheque.id}`"
                    :showDocumentView="true"
                    :documentsUrl="`document/payment/${cheque.id}`"
                    downloadUrl="document/:id/download"
                    removeUrl="document/:id"
                  ></FileUpload>
                </v-col>
              </v-row>
            </v-col> -->
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-row>
                <v-col cols="12" sm="12" md="12" lg="12">
                  <v-card class="lighten-12">
                    <v-card-title class="v-card__title saletiltle"
                      ><v-icon color="blue" small>mdi-sale</v-icon
                      ><span class="ml-3"> Doucment </span></v-card-title
                    >
                    <v-row>
                      <v-col class="mt-0" cols="12">
                        <FileUpload
                          v-if="show"
                          :multiple="true"
                          size="2048"
                          icon="mdi-upload"
                          autoupload="true"
                          :url="`document/upload/payment/${cheque.id}`"
                          :showDocumentView="true"
                          :documentsUrl="`document/payment/${cheque.id}`"
                          downloadUrl="document/:id/download"
                          removeUrl="document/:id"
                        ></FileUpload>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <ChequePdf ref="pdfCheque" v-show="false" :ChequeDetails="cheque" />
        </v-container>
      </custom-modal>
    </v-dialog>
  </v-row>
</template>

<script>
import PurchaseAutoComplete from '@/components/base/PurchaseAutoComplete';
import SaleAutoComplete from '@/components/base/SaleAutoComplete';
import ChequePdf from './ChequePdf.vue';
import FileUpload from '@/components/base/FileUpload';
import { Cheque } from '../../models/Cheque';
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
  withValidation,
} from 'vee-validate';
import { required, email, max, numeric } from 'vee-validate/dist/rules';

extend('required', {
  ...required,
  message: '{_field_} is required',
});

export default {
  components: {
    FileUpload,
    ValidationProvider,
    ValidationObserver,
    ChequePdf,
    PurchaseAutoComplete,
    SaleAutoComplete,
  },
  data: () => ({
    paymentableType: '',
    selectedsale: '',
    paymentableId: '',
    showChequefor: false,
    isSale: false,
    isPurchase: false,
    items: [
      { title: 'Sale', value: 'sale' },
      { title: 'Purchase', value: 'purchase' },
    ],
    showEditCheque: true,
    showCompleteCheque: true,
    showReason: false,
    isDisabled: false,
    isDisabledChequefor: false,
    isLoading: false,
    show: false,
    cheque: {},
    status: [
      // { text: "Pending", value: "Pending" },
      // { text: "Bounced", value: "Bounced" },
      { text: 'Canceled', value: 'Canceled' },
      { text: 'Completed', value: 'Completed' },
    ],
    statusComplete: [{ text: 'Return', value: 'Return' }],
    selectedStatus: null,
    chequeId: null,
    reason: '',
  }),
  props: {},
  computed: {},
  methods: {
    changePaymentType(item) {
      if (item.value == 'sale') {
        this.isSale = true;
        this.isPurchase = false;
        this.showChequefor = true;
        this.paymentableType = item.value;
      }
      if (item.value == 'purchase') {
        this.isPurchase = true;
        this.isSale = false;
        this.showChequefor = true;
        this.paymentableType = item.value;
      }
    },
    PrintPdfConfirmation() {
      setTimeout(() => {
        this.$refs.pdfCheque.print();
      }, 100);
    },
    editChequeStatus() {
      this.showEditCheque = false;
    },
    editChequeCompleteStatus() {
      this.showCompleteCheque = false;
    },

    onChequeClick(event) {
      if (event.chequeFor == 'sale') {
        this.$router.push(`/sales/view/${event.redirectId}`);
      }
      if (event.chequeFor == 'purchase') {
        this.$router.push(`/purchase/${event.redirectId}`);
      }
    },

    cancelEditChequeStatus() {
      this.showEditCheque = true;
      this.showCompleteCheque = true;
      this.selectedStatus = this.cheque.status;
      this.reason = '';
    },
    cancelChequeFor() {
      this.showChequefor = false;
    },
    onClose() {
      this.$emit('onClose', true);
      this.isPurchase = false;
      this.isSale = false;
    },
    async updateChequeStatus() {
      if (await this.$refs.observer.validate()) {
        this.isLoading = true;
        let payload = {
          id: this.cheque.id,
          status: this.selectedStatus,
          remarks: this.reason,
        };
        this.isDisabled = true;
        this.$store
          .dispatch('chequeManagement/changeChequeStatus', payload)
          .then((res) => {
            this.isLoading = false;
            this.isDisabled = false;
            this.$toast.success('Cheque status updated successfully');
            this.getCheque(this.chequeId);
            this.showEditCheque = true;
            this.showCompleteCheque = true;
            this.reason = '';
          })
          .catch((err) => {
            this.selectedStatus = this.cheque.status;
            this.isDisabled = false;
            this.$toast.error('Failed to update cheque status.');
            this.isLoading = false;
          });
      }
    },
    async updateChequeFor() {
      this.isLoading = true;
      let payload = {
        id: this.cheque.id,
        paymentable_id: this.paymentableId,
        paymentable_type: this.paymentableType,
      };
      this.isDisabledChequefor = true;
      this.$store
        .dispatch('chequeManagement/changeChequeFor', payload)
        .then((res) => {
          this.isLoading = false;
          this.isDisabledChequefor = false;
          this.$toast.success('Cheque updated successfully');
          this.getCheque(this.chequeId);
          this.showChequefor = false;
          this.paymentable_id = '';
          this.paymentable_type = '';
        })
        .catch((err) => {
          this.isDisabledChequefor = false;
          this.$toast.error('Cheque update failed');
          this.isLoading = false;
          this.showChequefor = true;
        });
    },
    openModal(chequeId) {
      this.chequeId = chequeId;
      this.show = true;
      this.showEditCheque = true;
      this.showCompleteCheque = true;
      this.getCheque(chequeId);
    },
    getCheque(id) {
      this.$store
        .dispatch('chequeManagement/GetCheque', id)
        .then((res) => {
          this.cheque = new Cheque().toViewModel(res.data);
          this.selectedStatus = this.cheque.status;
          this.setShowEdit();
          this.setShowReason();
          this.$store.commit('UPDATE_PRINT_CHEQUE', this.cheque);
        })
        .catch((err) => {});
    },
    setShowEdit() {
      if (this.cheque.status == 'Pending') {
        this.showEditCheque = true;
      }
      if (this.cheque.status == 'Completed') {
        this.showCompleteCheque = true;
      }
    },
    setShowReason() {
      if (
        this.selectedStatus == 'Canceled' ||
        this.selectedStatus == 'Bounced'
      ) {
        this.showReason = true;
      } else {
        this.showReason = false;
      }
    },
    getStatusColor(status) {
      switch (status) {
        case 'Completed':
          return 'green';
          break;
        case 'Pending':
          return 'orange';
          break;
        case 'Canceled':
          return 'red';
          break;
        case 'Return':
          return '#973a5a';
          break;
        default:
          break;
      }
    },
  },
  created() {},
};
</script>

<style scoped>
.saledetailscard {
  background: #fffefe;
  box-sizing: border-box;
  border: 1px solid #afa9a9;
  box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
}
.saletiltle {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
}
.reference_number {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 21px;
  /* identical to box height */

  text-align: left;

  color: #2841b1;
}
.statustext {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 12px;
  /* identical to box height */

  text-align: center;

  color: #045894;
}
.shoptext {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 14px;
  /* identical to box height */

  text-align: center;

  color: #000000;
}
.borderline {
  border: 1px dashed #4e879f;
}
.subtextlable {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 9px;
  line-height: 11px;
  /* identical to box height */

  text-align: left;

  color: #928686;
}
.paymenttext {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 12px;
  /* identical to box height */

  text-align: left;

  color: #928686;
}
.pulse {
  background: #2c44cc;

  animation: pulse 2s infinite;
}

.pointer {
  cursor: pointer;
}

@keyframes pulse {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(102, 15, 15, 0.4);
    box-shadow: 0 0 0 0 rgba(6, 173, 233, 0.4);
  }
  70% {
    -moz-box-shadow: 0 0 0 0 rgba(102, 15, 15, 0.4);
    box-shadow: 0 0 0 10px rgba(204, 169, 44, 0);
  }
  100% {
    -moz-box-shadow: 0 0 0 0 rgba(102, 15, 15, 0.4);
    box-shadow: 0 0 0 0 rgba(179, 52, 30, 0);
  }
}
</style>
